import {
  woolloongabbaArticles, westEndArticles,
  southBrisbaneArticles, kangarooPointArticles, fortitudeValleyArticles, newsteadArticles, teneriffeArticles, newFarmArticles,
  toowongArticles, kelvinGroveArticles, springHillArticles, herstonArticles, bowenHillsArticles, albionArticles, clayfieldArticles,
  miltonArticles, paddingtonArticles, redHillArticles, auchenflowerArticles, duttonParkArticles, highgateHillArticles, eastBrisbaneArticles, normanParkArticles,
  greenslopesArticles, coorparooArticles, morningsideArticles, bulimbaArticles, hawthorneArticles, windsorArticles, wilstonArticles, lutwycheArticles,
  surfersParadiseArticles, broadbeachArticles, burleighHeadsArticles, southportArticles, robinaArticles, coomeraArticles, palmBeachArticles, nerangArticles, mudgeerabaArticles, coolangattaArticles,
  springwoodArticles, beenleighArticles, brownsPlainsArticles, marsdenArticles, loganholmeArticles, shailerParkArticles, waterfordArticles, loganCentralArticles, meadowbrookArticles, woodridgeArticles,
  northLakesArticles, redcliffeArticles, cabooltureArticles, strathpineArticles, petrieArticles, deceptionBayArticles, burpengaryArticles, narangbaArticles, morayfieldArticles, kallangurArticles,
  clevelandArticles, capalabaArticles, victoriaPtArticles, redlandBayArticles, alexandraHillsArticles, wellingtonPtArticles, thornlandsArticles, ormistonArticles, birkdaleArticles, sheldonArticles,
  springfieldArticles, ipswichCbdArticles, goodnaArticles, brassallArticles, boovalArticles, karaleeArticles, ripleyArticles, rosewoodArticles, bundambaArticles, redbankPlainsArticles,
  maroochydoreArticles, caloundraArticles, mooloolabaArticles, buderimArticles, nambourArticles, kawanaArticles, sippyDownsArticles, palmwoodsArticles, landsboroughArticles, beerwahArticles,
  toowoombaCbdArticles, rangevilleArticles, eastToowoombaArticles, harristownArticles, wilsontonArticles, darlingHeightsArticles, highfieldsArticles, newtownArticles,
  noosaHeadsArticles, noosavilleArticles, tewantinArticles, cooroyArticles, pomonaArticles,
  beaudesertArticles, tamborineMountainArticles, boonahArticles, canungraArticles, mountTamborineArticles,
  gattonArticles, laidleyArticles, plainlandArticles, withcottArticles, forestHillArticles,
  eskArticles, kilcoyArticles, fernvaleArticles, lowoodArticles, toogoolawahArticles,
} from './suburbs';

export const councils = [
  {
    slug: 'brisbane',
    name: 'Brisbane City Council',
    shortName: 'Brisbane',
    description: 'Brisbane is Queensland\'s capital and Australia\'s third-largest city. As the epicentre of South East Queensland\'s growth, Brisbane\'s inner and middle-ring suburbs offer some of Australia\'s most compelling development site opportunities, driven by Cross River Rail, Brisbane Metro, and the 2032 Olympics.',
    keyStats: { suburbs: 31, articles: 310, population: '1.28M' },
    suburbs: [
      { name: 'Woolloongabba', articles: woolloongabbaArticles },
      { name: 'West End', articles: westEndArticles },
      { name: 'South Brisbane', articles: southBrisbaneArticles },
      { name: 'Kangaroo Point', articles: kangarooPointArticles },
      { name: 'Fortitude Valley', articles: fortitudeValleyArticles },
      { name: 'Newstead', articles: newsteadArticles },
      { name: 'Teneriffe', articles: teneriffeArticles },
      { name: 'New Farm', articles: newFarmArticles },
      { name: 'Toowong', articles: toowongArticles },
      { name: 'Kelvin Grove', articles: kelvinGroveArticles },
      { name: 'Spring Hill', articles: springHillArticles },
      { name: 'Herston', articles: herstonArticles },
      { name: 'Bowen Hills', articles: bowenHillsArticles },
      { name: 'Albion', articles: albionArticles },
      { name: 'Clayfield', articles: clayfieldArticles },
      { name: 'Milton', articles: miltonArticles },
      { name: 'Paddington', articles: paddingtonArticles },
      { name: 'Red Hill', articles: redHillArticles },
      { name: 'Auchenflower', articles: auchenflowerArticles },
      { name: 'Dutton Park', articles: duttonParkArticles },
      { name: 'Highgate Hill', articles: highgateHillArticles },
      { name: 'East Brisbane', articles: eastBrisbaneArticles },
      { name: 'Norman Park', articles: normanParkArticles },
      { name: 'Greenslopes', articles: greenslopesArticles },
      { name: 'Coorparoo', articles: coorparooArticles },
      { name: 'Morningside', articles: morningsideArticles },
      { name: 'Bulimba', articles: bulimbaArticles },
      { name: 'Hawthorne', articles: hawthorneArticles },
      { name: 'Windsor', articles: windsorArticles },
      { name: 'Wilston', articles: wilstonArticles },
      { name: 'Lutwyche', articles: lutwycheArticles },
    ],
  },
  {
    slug: 'gold-coast',
    name: 'Gold Coast City Council',
    shortName: 'Gold Coast',
    description: 'Australia\'s sixth-largest city and premier coastal destination. The Gold Coast is experiencing transformational growth driven by the G:link light rail, the 2032 Olympics, and sustained interstate migration. From high-rise Surfers Paradise to the hinterland fringe, development opportunities span the full spectrum.',
    keyStats: { suburbs: 10, articles: 100, population: '680K' },
    suburbs: [
      { name: 'Surfers Paradise', articles: surfersParadiseArticles },
      { name: 'Broadbeach', articles: broadbeachArticles },
      { name: 'Burleigh Heads', articles: burleighHeadsArticles },
      { name: 'Southport', articles: southportArticles },
      { name: 'Robina', articles: robinaArticles },
      { name: 'Coomera', articles: coomeraArticles },
      { name: 'Palm Beach', articles: palmBeachArticles },
      { name: 'Nerang', articles: nerangArticles },
      { name: 'Mudgeeraba', articles: mudgeerabaArticles },
      { name: 'Coolangatta', articles: coolangattaArticles },
    ],
  },
  {
    slug: 'logan',
    name: 'Logan City Council',
    shortName: 'Logan',
    description: 'Positioned between Brisbane and the Gold Coast, Logan is one of SEQ\'s fastest-growing municipalities. Heavy rail connectivity, major retail centres, and healthcare infrastructure drive development demand across affordable suburban markets with strong rental yields.',
    keyStats: { suburbs: 10, articles: 100, population: '365K' },
    suburbs: [
      { name: 'Springwood', articles: springwoodArticles },
      { name: 'Beenleigh', articles: beenleighArticles },
      { name: 'Browns Plains', articles: brownsPlainsArticles },
      { name: 'Marsden', articles: marsdenArticles },
      { name: 'Loganholme', articles: loganholmeArticles },
      { name: 'Shailer Park', articles: shailerParkArticles },
      { name: 'Waterford', articles: waterfordArticles },
      { name: 'Logan Central', articles: loganCentralArticles },
      { name: 'Meadowbrook', articles: meadowbrookArticles },
      { name: 'Woodridge', articles: woodridgeArticles },
    ],
  },
  {
    slug: 'moreton-bay',
    name: 'Moreton Bay Regional Council',
    shortName: 'Moreton Bay',
    description: 'Australia\'s third-largest local government area by population, Moreton Bay is experiencing transformational growth. The new Redcliffe Peninsula rail line, USC Moreton Bay campus, and master-planned communities like North Lakes drive development across the northern corridor.',
    keyStats: { suburbs: 10, articles: 100, population: '500K' },
    suburbs: [
      { name: 'North Lakes', articles: northLakesArticles },
      { name: 'Redcliffe', articles: redcliffeArticles },
      { name: 'Caboolture', articles: cabooltureArticles },
      { name: 'Strathpine', articles: strathpineArticles },
      { name: 'Petrie', articles: petrieArticles },
      { name: 'Deception Bay', articles: deceptionBayArticles },
      { name: 'Burpengary', articles: burpengaryArticles },
      { name: 'Narangba', articles: narangbaArticles },
      { name: 'Morayfield', articles: morayfieldArticles },
      { name: 'Kallangur', articles: kallangurArticles },
    ],
  },
  {
    slug: 'redland',
    name: 'Redland City Council',
    shortName: 'Redlands',
    description: 'The Redlands offer bayside living on Moreton Bay with heavy rail connectivity to Brisbane via the Cleveland line. From waterfront Cleveland to semi-rural Sheldon, the Redlands combine coastal lifestyle with genuine development opportunities around established suburban centres.',
    keyStats: { suburbs: 10, articles: 100, population: '162K' },
    suburbs: [
      { name: 'Cleveland', articles: clevelandArticles },
      { name: 'Capalaba', articles: capalabaArticles },
      { name: 'Victoria Point', articles: victoriaPtArticles },
      { name: 'Redland Bay', articles: redlandBayArticles },
      { name: 'Alexandra Hills', articles: alexandraHillsArticles },
      { name: 'Wellington Point', articles: wellingtonPtArticles },
      { name: 'Thornlands', articles: thornlandsArticles },
      { name: 'Ormiston', articles: ormistonArticles },
      { name: 'Birkdale', articles: birkdaleArticles },
      { name: 'Sheldon', articles: sheldonArticles },
    ],
  },
  {
    slug: 'ipswich',
    name: 'Ipswich City Council',
    shortName: 'Ipswich',
    description: 'Queensland\'s fastest-growing local government area. Ipswich combines heritage city character with massive growth corridors like Springfield and Ripley Valley. Heavy rail to Brisbane, the Nicholas Street CBD revitalisation, and Australia\'s largest master-planned communities make Ipswich SEQ\'s western growth engine.',
    keyStats: { suburbs: 10, articles: 100, population: '250K' },
    suburbs: [
      { name: 'Springfield', articles: springfieldArticles },
      { name: 'Ipswich CBD', articles: ipswichCbdArticles },
      { name: 'Goodna', articles: goodnaArticles },
      { name: 'Brassall', articles: brassallArticles },
      { name: 'Booval', articles: boovalArticles },
      { name: 'Karalee', articles: karaleeArticles },
      { name: 'Ripley Valley', articles: ripleyArticles },
      { name: 'Rosewood', articles: rosewoodArticles },
      { name: 'Bundamba', articles: bundambaArticles },
      { name: 'Redbank Plains', articles: redbankPlainsArticles },
    ],
  },
  {
    slug: 'sunshine-coast',
    name: 'Sunshine Coast Council',
    shortName: 'Sunshine Coast',
    description: 'One of Australia\'s fastest-growing regions, the Sunshine Coast combines world-class beaches with the transformational SunCentral Maroochydore CBD, the $2B+ Sunshine Coast University Hospital, and proposed mass transit. From premium Mooloolaba to affordable Beerwah, opportunities span the full coast.',
    keyStats: { suburbs: 10, articles: 100, population: '360K' },
    suburbs: [
      { name: 'Maroochydore', articles: maroochydoreArticles },
      { name: 'Caloundra', articles: caloundraArticles },
      { name: 'Mooloolaba', articles: mooloolabaArticles },
      { name: 'Buderim', articles: buderimArticles },
      { name: 'Nambour', articles: nambourArticles },
      { name: 'Kawana Waters', articles: kawanaArticles },
      { name: 'Sippy Downs', articles: sippyDownsArticles },
      { name: 'Palmwoods', articles: palmwoodsArticles },
      { name: 'Landsborough', articles: landsboroughArticles },
      { name: 'Beerwah', articles: beerwahArticles },
    ],
  },
  {
    slug: 'toowoomba',
    name: 'Toowoomba Regional Council',
    shortName: 'Toowoomba',
    description: 'Australia\'s largest inland non-capital city, Toowoomba sits atop the Great Dividing Range. The $1.6B Second Range Crossing has transformed Brisbane connectivity. A new hospital, USQ university, and Wellcamp Airport drive development interest across this heritage regional city.',
    keyStats: { suburbs: 8, articles: 80, population: '175K' },
    suburbs: [
      { name: 'Toowoomba CBD', articles: toowoombaCbdArticles },
      { name: 'Rangeville', articles: rangevilleArticles },
      { name: 'East Toowoomba', articles: eastToowoombaArticles },
      { name: 'Harristown', articles: harristownArticles },
      { name: 'Wilsonton', articles: wilsontonArticles },
      { name: 'Darling Heights', articles: darlingHeightsArticles },
      { name: 'Highfields', articles: highfieldsArticles },
      { name: 'Newtown', articles: newtownArticles },
    ],
  },
  {
    slug: 'noosa',
    name: 'Noosa Shire Council',
    shortName: 'Noosa',
    description: 'One of Australia\'s most exclusive coastal addresses. Noosa\'s strict 4-storey height limits create extreme scarcity for development sites. From world-renowned Hastings Street to the hinterland villages of Cooroy and Pomona, Noosa commands premium pricing reflecting its irreplaceable lifestyle positioning.',
    keyStats: { suburbs: 5, articles: 50, population: '58K' },
    suburbs: [
      { name: 'Noosa Heads', articles: noosaHeadsArticles },
      { name: 'Noosaville', articles: noosavilleArticles },
      { name: 'Tewantin', articles: tewantinArticles },
      { name: 'Cooroy', articles: cooroyArticles },
      { name: 'Pomona', articles: pomonaArticles },
    ],
  },
  {
    slug: 'scenic-rim',
    name: 'Scenic Rim Regional Council',
    shortName: 'Scenic Rim',
    description: 'The Scenic Rim stretches from Tamborine Mountain to Boonah at the base of the Great Dividing Range. National parks, gallery walks, and rural landscapes define this lifestyle-focused region attracting tree-changers and retirees seeking character and natural beauty.',
    keyStats: { suburbs: 5, articles: 25, population: '45K' },
    suburbs: [
      { name: 'Beaudesert', articles: beaudesertArticles },
      { name: 'Tamborine Mountain', articles: tamborineMountainArticles },
      { name: 'Boonah', articles: boonahArticles },
      { name: 'Canungra', articles: canungraArticles },
      { name: 'Mount Tamborine', articles: mountTamborineArticles },
    ],
  },
  {
    slug: 'lockyer-valley',
    name: 'Lockyer Valley Regional Council',
    shortName: 'Lockyer Valley',
    description: 'Known as "Australia\'s Salad Bowl" for its productive farmland, the Lockyer Valley offers affordable rural living within commuting distance of Brisbane. The UQ Gatton Campus and improving Warrego Highway connectivity attract growing residential interest.',
    keyStats: { suburbs: 5, articles: 25, population: '45K' },
    suburbs: [
      { name: 'Gatton', articles: gattonArticles },
      { name: 'Laidley', articles: laidleyArticles },
      { name: 'Plainland', articles: plainlandArticles },
      { name: 'Withcott', articles: withcottArticles },
      { name: 'Forest Hill', articles: forestHillArticles },
    ],
  },
  {
    slug: 'somerset',
    name: 'Somerset Regional Council',
    shortName: 'Somerset',
    description: 'The Somerset Region offers the most affordable rural lifestyle in South East Queensland. Lake Wivenhoe, Somerset Dam, the Brisbane Valley Rail Trail, and charming heritage townships attract lifestyle buyers, retirees, and adventure enthusiasts.',
    keyStats: { suburbs: 5, articles: 25, population: '28K' },
    suburbs: [
      { name: 'Esk', articles: eskArticles },
      { name: 'Kilcoy', articles: kilcoyArticles },
      { name: 'Fernvale', articles: fernvaleArticles },
      { name: 'Lowood', articles: lowoodArticles },
      { name: 'Toogoolawah', articles: toogoolawahArticles },
    ],
  },
];
